import baseURL from './baseURL'

export default baseURL + '/api'
